export const handlePermissionSendFollowUp = (statusSinister: string) => {
	if (statusSinister == "sketch") {
		return false;
	}
	if (statusSinister == "canceled") {
		return false;
	}
	if (statusSinister == "finalized") {
		return false;
	}
	if (statusSinister == "monthly_compensation") {
		return true;
	}
	if (statusSinister == "lmi_exhaustion") {
		return true;
	}
	if (statusSinister == "pending") {
		return true;
	}
	if (statusSinister == "debts_confession") {
		return true;
	}
	return true;
};
